"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateStartIndices = void 0;
const generateStartIndices = (cells) => {
    if (cells.length === 0) {
        return [];
    }
    const startIndices = [0];
    for (let startIndex = 1; startIndex < cells.length - 1; ++startIndex) {
        if (!cells[startIndex - 1].hasTile()) {
            startIndices.push(startIndex);
        }
    }
    return startIndices;
};
exports.generateStartIndices = generateStartIndices;
